import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useServiceMenu() {
  var queryApi = useDeviceQueryApi();
  return queryApi.useServiceMenuQuery();
}